//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';

import './HeroCarousel.css';

//
// TODO: retrieve these items from the database - will allow staff to upload pictures and change text indepedently
//
const loadedItemList = [
    {
        src: `./img/splash/splash3.jpg`,
        title: `Inviting social lounge.`,
        details: `Comfy couches, a large byob bar area, and high top tables to make it easy to meet and mingle with likeminded adults.`,
    },
    {
        src: `./img/splash/splash2.jpg`,
        title: `Explore your darkest desires.`,
        details: `Our dungeon spaces are filled with hand crafted furniture covering a wide array of fantasties for you to explore at your own pace.`,
    },
    {
        src: `./img/splash/splash1.jpg`,
        title: `Specialized fantasy rooms.`,
        details: `Got a particular place you've always wanted to try playing at like the massage table, school room, or other off limits location? We've got something special for you!`,
    }
];


export function HeroCarousel() {

    const [items] = useState(loadedItemList);

    const slides = items.map((item) => {
        return (
            <Carousel.Item key={item.src}>
                <img className="d-block w-100" src={item.src} alt={item.title} />
                <Carousel.Caption>
                    <h1>{item.title}</h1>
                    <div>{item.details}</div>
                    <div className="action-button">
                        <Link to="/join">
                            <Button>Join Now</Button>
                        </Link>
                    </div>
                </Carousel.Caption>
            </Carousel.Item>
        );
    });

    return (
        <Carousel fade>
            {slides}
        </Carousel>
    );
}
